/* PICKAWALL — cart bundle helpers
 * 1. Adjusts the cart-count badge so bundle children & unit-pricing lines
 *    don't inflate the displayed count (a bundle counts as one item).
 * 2. Intercepts remove clicks on lines flagged as bundle bases so both the
 *    base and the surcharge sibling are removed together.
 */
(() => {
  if (window.__pwCartHelpersInstalled) return;
  window.__pwCartHelpersInstalled = true;

  /** Re-compute "real" item count from a /cart.js style payload. */
  const pwAdjustedCount = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return 0;
    let n = 0;
    for (const li of cart.items) {
      const props = li.properties || {};
      const kind = props._pw_kind || '';
      const unit = props._pw_unit_pricing;
      if (kind === 'surcharge') continue;
      if (kind === 'base' || unit) n += 1;
      else n += Number(li.quantity || 0);
    }
    return n;
  };

  const applyCount = (n) => {
    document.querySelectorAll('cart-count').forEach((el) => {
      el.textContent = String(n);
    });
  };

  // Update on cart:change (drawer add/remove)
  document.addEventListener('cart:change', (e) => {
    const cart = e?.detail?.cart;
    if (cart) applyCount(pwAdjustedCount(cart));
  });

  // Update on cart:refresh (fetches /cart.js)
  const refresh = async () => {
    try {
      const r = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!r.ok) return;
      const cart = await r.json();
      applyCount(pwAdjustedCount(cart));
    } catch { /* non-fatal */ }
  };
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', refresh);

  // Intercept remove clicks on bundle base lines and clear the surcharge
  // sibling at the same time. We use /cart/update.js with line keys so the
  // two removals are atomic (no line-index renumbering race).
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('a[data-pw-surcharge-key]');
    if (!a) return;
    const surchargeKey = a.getAttribute('data-pw-surcharge-key');
    const baseKey = a.getAttribute('data-pw-base-key');
    if (!surchargeKey || !baseKey) return;

    e.preventDefault();
    a.style.pointerEvents = 'none';

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try {
      const r = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: { [baseKey]: 0, [surchargeKey]: 0 } }),
      });
      if (!r.ok) throw new Error('cart/update failed');
      const cart = await r.json();
      applyCount(pwAdjustedCount(cart));
      // Re-fetch the cart-drawer section markup and swap it in-place.
      try {
        const sr = await fetch(`${window.location.pathname}?sections=cart-drawer`, { credentials: 'same-origin' });
        if (sr.ok) {
          const data = await sr.json();
          const html = data['cart-drawer'];
          if (html) {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const fresh = tmp.querySelector('cart-drawer');
            const live = document.querySelector('cart-drawer');
            if (fresh && live) live.replaceWith(fresh);
          }
        }
      } catch { /* non-fatal */ }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      // On the cart page proper, reload so the table reflects the change.
      if (document.querySelector('.cart-page')) {
        window.location.reload();
      }
    } catch (err) {
      a.style.pointerEvents = '';
      // Fallback to the standard remove URL.
      window.location.href = a.getAttribute('href') || '/cart';
    }
  });
})();
